import React from 'react';

export const TabContext = React.createContext(null);
